module.exports = __webpack_public_path__ + "img/logo-modular.759d83ab.png";